import { Component, inject, input, model, output, signal } from '@angular/core';
import { RolesService } from '../services/roles.service';
import { ProfileService } from '../../profile/services/profile.service';
import { RoutesService } from '../../shared/services/routes.service';
import { User } from '../../shared/models/user.model';
import { RoleModel } from '../../shared/models/role.model';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { ButtonGroupModule } from 'primeng/buttongroup';
import { RippleModule } from 'primeng/ripple';
import { ChipModule } from 'primeng/chip';
import { CardModule } from 'primeng/card';
import { AccessService } from '../../core/services/access.service';
import { ResourceFormCardComponent } from "../../shared/components/resource-form-card/resource-form-card.component";
import { ResourceButtonGroupComponent } from "../../shared/components/resource-button-group/resource-button-group.component";

@Component({
  selector: 'app-roles-list',
  standalone: true,
  imports: [
    CardModule,
    TableModule,
    ButtonModule,
    ButtonGroupModule,
    RippleModule,
    ChipModule,
    ResourceFormCardComponent,
    ResourceButtonGroupComponent
],
  templateUrl: './roles-list.component.html',
  styleUrl: './roles-list.component.css'
})
export class RolesListComponent {
  protected service = inject(RolesService)
  protected routesService = inject(RoutesService)

  protected access = inject(AccessService).access
  protected resource = this.service.resource
  public detailed = model<boolean>(true);

  protected value = this.service.roles

  public length = output<number>()

  ngOnInit(): void {
    this.service.title.update((value) => 'Lista de Roles')
    this.service.get().subscribe(data => {
      this.value.update(value => {
        value = data as RoleModel[];
        this.length.emit(value.length)
        return value;
      });
    })
  }
}
